module.exports = __webpack_public_path__ + "static/media/envelope.5587f2a5.svg";